<script>
  import RfpSpecificationMenuItem from 'root/components/organisms/SideNavigation/RfpSpecificationMenuItem.svelte';

  export let maximized, minimized;
</script>

<RfpSpecificationMenuItem stateName="hotelRfp.rfp.specifications" {maximized} {minimized}/>
